import { StatusEnum } from '../../shared/enums.model';
export class DashboardPiListBE {
    Id: number;
    Message: string
    InstructionId: number;
    PIName: string
    ByUserId: string
    ByUserName: string
    IssuerUserId: string
    IssuerUserName: string
    ActionDate: Date;
    StartDate: Date;
    FromStatusId: number;
    ToStatusId: number;
    FromStatusDescription: string
    TosStatusDescription: string
    PartNo: string
    PartDescription: string
    SupplierNo: string
    SupplierName: string
    PIStatus: number;
    Activated: boolean;
    SupplierId: number;
    SuggestedStartDate: Date;
    SuppApprovedSelected: boolean = false;
    RejectSelected: boolean = false;
    PackagingType: number;
    ExtendedSupplierNo: string;
}

export class DashboardPiMultiSupplierListBE {
    InstructionId: number = 0;
    PackagingType: number = 1;
    PartNo: string = "";
    PartDescription: string = "";
    IssuerUserName: string = "";
    SentToMultiSelected: boolean = false;
    SupplierResponses: DashboardPiListBE[] = [];
}

export class ApprovalFlowBE {
    Message: string = "";
    InstructionId: number = 0;
    UserId: string = "";
    FromStatusId: StatusEnum;
    ToStatusId: StatusEnum;
    StartDate: string;
    SupplierId: number = -1;
    ApproverOrRejectorSupplierId: number;
    InstructionType: number ;

}

export class PiHistoryListBE {
    Message: string;
    ByUserId: string;
    ByUserName: string;
    ActionDate: string;
    FromStatus: string;
    ToStatus: string;
    SuggestedStartDate: string;
    supplierNo: string;
    supplierName: string;
    approvedSupplierNo: string;
    approvedSupplierName: string;
}

export class DashboardPartPruBE {
    SupplierName: string = '';
    SupplierNo: string = '';
    PartNo: string = '';
    Changed: Date;
    PruCode: string = '';
    PruDescription: string = '';
    PruCodeName: string = '';
}



// WEBPACK FOOTER //
// C:/PackIT/New-Seq-Backend/PackITWebGui/src/app/dashboard/shared/dashboard.model.ts



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/dashboard/shared/dashboard.model.ts